// extracted by mini-css-extract-plugin
module.exports = {"video_list":"video_list_video_list__3Rj6L"};